module.exports = __webpack_public_path__ + "static/reclambcomforter-9e7c471a00e9a4e40f563440e02fb76c.jpeg";